import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component for the IoT pairing QR scanner (CONEK-4143).
//
// Wires the web-side `iot--qr-scan` Stimulus controller to the native
// Android ZXing camera scanner provided by
// `mobile/android/app/.../bridge/BarcodeComponent.kt`.
//
// Contract (canonical — must stay in sync with the Kotlin side):
//
//   Web → Native:
//     event: "scan"
//     data: { label?: String, expected_format?: String = "QR_CODE" }
//
//   Native → Web (success):
//     event: "scanned"
//     data: { value: String, format: String }
//
//   Native → Web (cancelled or error):
//     event: "scanned"
//     data: { error: String }
//
// On reply, dispatches a `barcode:scanned` CustomEvent on this element's
// host so the `iot--qr-scan` controller (which listens for it) can write
// the decoded value into the paired input. The browser path (when no
// native bridge is present) is handled by the html5-qrcode fallback in
// `iot/qr_scan_controller.js` — this bridge is a no-op on the desktop.
export default class extends BridgeComponent {
  static component = "barcode"

  // Called from `iot--qr-scan` via the Stimulus outlet API or directly via
  // a `data-action` invoke. Forwards the request to native and waits for
  // the `scanned` reply.
  scan(metadata = {}) {
    this.send("scan", {
      label: metadata.label || "",
      expected_format: metadata.expected_format || "QR_CODE",
    })
  }

  // Receiver for the native reply. The framework matches `scanned` against
  // a method with the same name camelCased.
  scanned(message) {
    const data = (message && message.data) || {}
    const detail = data.error
      ? { error: data.error }
      : { value: data.value, format: data.format }

    this.element.dispatchEvent(
      new CustomEvent("barcode:scanned", { bubbles: true, detail }),
    )
  }
}
